/** 디자이너 가이드 기준. MUI 기본값과 무관하며 color 는 Figma 토큰 gray-3 */
export const SKELETON_TOKENS = {
  // 앱 웹뷰 다크 모드에서는 다크 면 (styles/appDarkMode.ts)
  color: 'var(--dk-bg-strong, #E7E9EC)',
  radius: '4px',
  height: 20,
  duration: '1.8s',
  timing: 'ease-in-out',
  minOpacity: 0.45,
} as const;

export const SKELETON_PULSE_NAME = 'portal-skeleton-pulse';

/** 가이드가 정한 pulse. MUI 내장 pulse(2s · 0.5s delay · opacity .4)와 값이 달라 직접 정의 */
export const skeletonPulse = {
  [`@keyframes ${SKELETON_PULSE_NAME}`]: {
    '0%, 100%': { opacity: 1 },
    '50%': { opacity: SKELETON_TOKENS.minOpacity },
  },
  animation: `${SKELETON_PULSE_NAME} ${SKELETON_TOKENS.duration} ${SKELETON_TOKENS.timing} infinite`,
};
